<template>
  <div class="password" style="padding: 0 1em;">
    <!-- <b-alert
      :show="alertObj.dismissCountDown"
      :variant="alertObj.type"
      @dismissed="alertObj.dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      dismissible
      fade>
      {{alertObj.msg}}
    </b-alert> -->

    <b-form @submit="onSubmit"  @reset="onReset" style="text-align:left;">

      <b-form-group id="input-group-1" label="帳號：" label-for="input-1"
        class="form_text">
        <b-form-select label-for="input-1" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem;"
          v-model="form.type"
          placeholder="請選擇帳號"
          :state="typeState"
          required>
          <b-form-select-option 
            :value="1">系統管理員</b-form-select-option>
          <b-form-select-option 
            :value="0" disabled>請選擇</b-form-select-option>         
        </b-form-select>
      </b-form-group>

      <b-form-group id="input-group-2" label="輸入舊密碼：" label-for="input-2"
        class="form_text">
        <b-form-input
          id="input-2"
          type="password"
          v-model="form.oldWords"
          placeholder="請輸入舊密碼"
          :state="wordState" trim
          required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3" label="輸入新密碼：" label-for="input-3"
        class="form_text">
        <b-form-input
          id="input-3"
          type="password"
          v-model="form.newPsd1"
          placeholder="請輸入新密碼..."
          :state="newState" trim
          required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-4" label="確認新密碼：" label-for="input-4"
        class="form_text">
        <b-form-input
          id="input-4"
          v-model="form.newPsd2"
          type="password"
          placeholder="請確認新密碼..."
          :state="newState" trim
          required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-5" label="密碼強度偵測：" label-for="input-5"
        class="form_text">
        <span>
        &nbsp;*密碼強度需求等級：中<br />
        &nbsp;*密碼最少須有8字元以上
        </span>
        <span>
          密碼強度：
          <span v-if="pwStrength==1" style="border-color: #FF0000; font-size: larger;">弱</span>
          <span v-else-if="pwStrength==2" style="border-color: #FF9900; font-size: larger;">中</span>
          <span v-else-if="pwStrength>2" style="border-color: #33CC00; font-size: larger;">強</span>
        </span>
        <span v-if="msg != ''" style="border-color: #eeeeee;"><br/><br/>*<b style="color:#5a1216;">請注意，{{msg}}</b></span>
      </b-form-group>
      <b-button type="submit" variant="success"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
    </b-form>    
  </div>
</template>

<script>
import * as tools from '@/tool';
export default {
  name: 'password',
  data () {
    return {
      pwStrength: 0,
      msg: '',
      alertObj: {
        msg: '',
        dismissCountDown: 0,
        type: ''
      },
      form: {
        type: 0,
        oldWords: '',
        newPsd1: '',
        newPsd2: ''
      },
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    typeState() {
        return (this.form.type !=0)
    },
    wordState() {
      return !tools.isNullOrWhiteSpace(this.form.oldWords)
    },
    newState() {
      var ret = false;
      if (!tools.isNullOrWhiteSpace(this.form.newPsd1)) {
        this.msg = this.checkSaveData();
        ret = tools.isNullOrWhiteSpace(this.msg);
      }
      return ret;
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.alertObj.dismissCountDown = dismissCountDown
    },
    // showAlert(type, text) { 
    //   const h = this.$createElement
    //   const vNodesMsg = h(
    //         'div',
    //         { class: ['alert-text'] },
    //         [
    //             h('strong', text)
    //         ] 
    //   );
    //   this.$bvToast.toast(vNodesMsg, {
    //                   title: '請注意',
    //                   variant: type,
    //                   autoHideDelay: 5000,
    //                   solid: true
    //                 });
    // },
    checkSaveData () {
      let msg = ''

      if (this.form.type === 0) {
        msg = '請輸入帳號'
      } else if (this.form.oldWords.length === 0) {
        msg = '請輸入舊密碼'
      } else if (this.form.newPsd1 !== this.form.newPsd2) {
        msg = '所輸入的密碼不一樣，請重新輸入'
      } else if (this.checkStrong(this.form.newPsd1) < 2) {
        msg = '密碼強度不足'
      }

      return msg
    },
    onSubmit(event) {
      event.preventDefault();
      var msg = this.checkSaveData()
      if (msg.length === 0) {
        var vm = this;
        let pData = {
          id   : this.sysId,
          type : this.form.type,
          text1: this.form.oldWords,
          text2: this.form.newPsd1
        }
        this.$http.put('./WebApi/Setting/SetPasswordData', pData)
            .then((response) => {
              switch (response.data) {
                case 0:
                  tools.showAlert(vm, 'success', '恭喜您,存檔成功');
                  break;
                case -2:
                  tools.showAlert(vm, 'danger', '對不起，舊密碼錯誤');
                  break;
                default:
                  tools.showAlert(vm, 'danger', '存檔失敗');
                  break;
              }
            })
            .catch(function (error) {
              tools.showAlert(vm, 'danger', '網路連線失敗' + error);
            })
      } else {
        tools.showAlert(this, 'danger', '對不起，' + msg);
      }
    },
    charMode (iN) {
      let ret = 0

      if ((iN >= 48) && (iN <= 57)) { // 數字
        ret = 1
      } else if ((iN >= 65) && (iN <= 90)) { // 大寫字母
        ret = 2
      } else if ((iN >= 97) && (iN <= 122)) { // 小寫
        ret = 4
      } else { // 特殊字符
        ret = 8
      }

      return ret
    },
    bitTotal (num) {
      let modes = 0

      for (var i = 0; i < 4; i++) {
        if (num & 1) {
          modes++
        }
        num >>>= 1
      }

      return modes
    },
    checkStrong (sPW) {
      let modes = 0

      if (sPW.length <= 7) {
        return 1 // 密碼太短
      }

      for (var i = 0; i < sPW.length; i++) {
        // 測試每一個字符的類別並統計一共有多少種模式.
        modes |= this.charMode(sPW.charCodeAt(i))
      }

      return this.bitTotal(modes)
    },
    onReset(event){
      event.preventDefault();
      this.form.oldWords = '';
      this.form.newPsd1 = '';
      this.form.newPsd2 = '';
    },
  },
  created () {
    //console.log('== Password ==');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form_text{
  padding: 0.25rem 1rem 0.5rem;
}
</style>